const setCookie = function(name, value, days) {
  let expires = ''

  if (days) {
    const date = new Date()
    date.setTime( date.getTime() + (days * 24 * 60 * 60 * 1000) )
    expires = '; expires=' + date.toUTCString()
  }

  document.cookie = `${name}=${value || ''}${expires}; path=/`
}

const getCookie = function(name) {
  const cookieName = name + '='
  const cookieArray = document.cookie.split(';')

  for (let cookie of cookieArray) {
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1, cookie.length)
    }
    if (cookie.indexOf(cookieName) == 0) {
      return cookie.substring(cookieName.length, cookie.length)
    }
  }

  return ''
}

const eraseCookie = function(name) {
  setCookie(name, '', -1)
}

export default { setCookie, getCookie, eraseCookie }
